var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 66,
    viewBox: "0 0 57 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6024 0H40.6975L56.9407 16.5407V61.4031C56.9407 63.9615 54.8583 65.9845 52.3593 65.9845H11.6024C9.04397 65.9845 7.021 63.9615 7.021 61.4031V4.64093C7.021 2.08247 9.04397 0 11.6024 0Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9407 16.5407H44.8624C42.5419 16.5407 40.6379 14.6368 40.6379 12.3163V0H40.6974L56.9407 16.5407Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9406 16.5407V28.6786L45.0408 16.5407H56.9406Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7548 31H2.43946C1.09218 31 0 32.0389 0 33.3205V52.7767C0 54.0582 1.09218 55.0971 2.43946 55.0971H45.7548C47.1021 55.0971 48.1943 54.0582 48.1943 52.7767V33.3205C48.1943 32.0389 47.1021 31 45.7548 31Z",
    fill: "#EDB20D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2556 44.4521H28.7195V42.8525H31.2556C31.6475 42.8525 31.9666 42.7887 32.2126 42.6611C32.4587 42.529 32.6388 42.3467 32.7527 42.1143C32.8666 41.8818 32.9236 41.6198 32.9236 41.3281C32.9236 41.0319 32.8666 40.7562 32.7527 40.501C32.6388 40.2458 32.4587 40.0407 32.2126 39.8857C31.9666 39.7308 31.6475 39.6533 31.2556 39.6533H29.4304V48H27.3796V38.0469H31.2556C32.0349 38.0469 32.7026 38.1882 33.2585 38.4707C33.8191 38.7487 34.2475 39.1338 34.5437 39.626C34.8399 40.1182 34.988 40.681 34.988 41.3145C34.988 41.957 34.8399 42.513 34.5437 42.9824C34.2475 43.4518 33.8191 43.8141 33.2585 44.0693C32.7026 44.3245 32.0349 44.4521 31.2556 44.4521Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2588 38.0469V48H23.2148V38.0469H25.2588Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5725 46.4004V48H14.5178V46.4004H21.5725ZM21.47 39.1885L15.427 48H13.9846V46.8242L20.0754 38.0469H21.47V39.1885ZM20.7659 38.0469V39.6533H13.9915V38.0469H20.7659Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1944 52.7757V55.0367C48.1944 56.3456 47.1234 57.3571 45.8144 57.3571H7.021V55.0962H45.8144C47.1234 55.0962 48.1944 54.0252 48.1944 52.7757Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/ZIP.d0a730fec88f6c959254bc9f736f59c7.svg";
export { ForwardRef as ReactComponent };